import resource from '@/api/report/resource'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  product_categories: [],
  date_from: moment().format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  }
}

export const actions = {
  getBranch(context, attributes = {}) {
    return resource.getBranch({ params: attributes })
  },
  getLocation(context, attributes = {}) {
    return resource.getLocation({ params: attributes })
  },
  getProduct(context, attributes = {}) {
    return resource.getProduct({ params: attributes })
  },
  getCashier(context, attributes = {}) {
    return resource.getCashier({ params: attributes })
  },
  getTransferNumber(context, attributes = {}) {
    return resource.getTransferNumber({
      params: Object.assign(
        {
          filter: {
            date_between: _.join(
              [context.state.date_from, context.state.date_to],
              ','
            ),
            transfer_type: attributes.transfer_type
          }
        },
        attributes
      )
    })
  },
  getSerialStatus(context) {
    return resource.serialStatus()
  },
  productCategory(context) {
    return resource.productCategory()
  },
  productProfileLocation(context, attributes = {}) {
    return resource.productProfileLocation({
      params: attributes
    })
  },
  productProfileLocationList(context, attributes = {}) {
    return resource.productProfileLocationList({
      params: attributes
    })
  },
  getEmployee(context){
    return resource.employee()
  },
  productGroup(context, attributes = {}) {
    return resource.productGroup({ params: attributes })
  },
  getCustomer(context) {
    return resource.getCustomer()
  }
}
